import React, { Component } from "react";
import patientIcon from "../../assets/images/Patient.svg";
import userIcon from "../../assets/images/user_color.svg";
import token from "../../assets/images/TokenGenerator.svg";
import service from "../../assets/images/service.svg";
import postService from "../../services/httpService";
import { Button, Input, Modal, Radio, Icon, Popover } from "antd";
import userTrackService from "../../services/usertrack-service";
import { ClockCircleOutlined } from '@ant-design/icons';
import { InfoCircleOutlined } from '@ant-design/icons';

import * as moment from "moment";
const { confirm } = Modal;
class DNPatientCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  renderTime(date) {
    return moment(date).format("hh:mm A");
  }
  vitals(data) {
    confirm({
      title: "Do you Want to Re-build the Queue ?",
      content: "",
      onOk() {
        let patient_id = patient_id.patient_id || "";
        if (patient_id !== undefined && patient_id !== null) {
       
          let obj = {
            patient_id: patient_id,
            "is_vitals_done":'YES'
          };
        
          let Userlogobj = {
            user: JSON.parse(Storage.get("user")),
            action: "set Patient Vitals DoneFlag- Request",
            date: new Date(),
            meta: obj,
          };
          userTrackService(Userlogobj);
          postService("setPatientVitalsDoneFlag", "POST", { data: obj }).then((res) => {
            let Userlogobjres = {
              user: JSON.parse(Storage.get("user")),
              action: "restore queue - response",
              date: new Date(),
              meta: res,
            };
            userTrackService(Userlogobjres);
            if (res) {
              //that.refreshQueueListData();
             
            }
          });
        }
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  }
  render() {
    const { item } = this.props;
    return (
      <div className="py-1 pl-4 pr-1 mr-1 mt-2 b-card-body disable-text">
        {/* Patientname */}
        <div className="row displaySpaceBetween">
          <div>
            <img alt="" src={patientIcon} className="patientIcon ml-0 mr-1" />

            <span className="Patientname">
              {item && item.name ? item.name : "--"}
            </span>
          </div>
          <div>
            <span class="buttonVitals" onClick={this.vitals.bind(this, item)}>
              Vitals
            </span>
          </div>
        </div>
        {/* phone - status */}
        <div className="row mt-1">
          <div>
            {/* <Icon
              type="info-circle"
              style={{
                color: "#ac7ab0",
                transform: "rotate(0deg)",
                fontSize: "15px",
                margin: "0 6px 0 -2px",
              }}
            // draggable={draggableStatus}
            /> */}
           

<InfoCircleOutlined
  style={{
    color: '#ac7ab0',
    transform: 'rotate(0deg)',
    fontSize: '15px',
    margin: '0 6px 0 -2px',
  }}
  // draggable={draggableStatus}
/>

            <span className="Patientname">
              {item.umr ? item.umr : "--"}
            </span>
          </div>
        </div>
        <div className="row">

          <div>
            <img
              alt=""
              src={userIcon}
              className="uidIcon"
            // draggable={draggableStatus}
            />

            <span className="Patientname">
              {item.service_name ? item.service_name : "--"}
            </span>
          </div>
        </div>
        <div className="row pr-3 mt-1 displaySpaceBetween">

          <div>

            <img
              alt=""
              src={service}
              // draggable={draggableStatus}
              className="uidIcon"
            />
            <span className="Patientname">
              {item.patienttype ? item.patienttype : "--"}
            </span>
          </div>
          <div>

            {/* <Icon
              type="clock-circle"
              style={{
                color: "#ac7ab0",
                transform: "rotate(0deg)",
                fontSize: "15px",
                margin: "0 6px 0 0",
              }}
            /> */}
           

<ClockCircleOutlined
  style={{
    color: '#ac7ab0',
    transform: 'rotate(0deg)',
    fontSize: '15px',
    margin: '0 6px 0 0',
  }}
/>

            <span className="Patientname">
              {item.appointment_date
                ? this.renderTime(item.appointment_date)
                : "--"}

            </span>
          </div>
        </div>

      </div>
    );
  }
}
export default DNPatientCard;
